<template>
	<div>

			<fw-table v-if="activeStep===1" :apiService="generalTableService" :grid-config="tableConfigData.gridConfig"
			 :grid-btn-config="tableConfigData.gridBtnConfig" :grid-top-btn-config="tableConfigData.gridTopBtnConfig"
			 :form-config="tableConfigData.formConfig" :form-data="tableConfigData.formModel" :grid-edit-width="200" form-title="表信息"
			 :is-async="true" :query-config="tableConfigData.queryConfig" :query-model="tableConfigData.queryModel"
			 :dialog-config="tableConfigData.dialogConfig" @stragetyonfig="stragetyonfig">
			</fw-table>
			<div v-if="activeStep===2" style="margin-top:10px;">
				<fw-form ref="strategyForm" :form-config="strategyConfigData.formConfig" :form-data="strategyConfigData.formModel"
				 @submit="saveStrategy" :dialog-config="strategyConfigData.dialogConfig">
				</fw-form>
				<span>
					<el-button type="warning" class="ml-10" @click="back">返回</el-button>
					<el-button type="primary" @click="saveStrategyForm">
						<span v-if="!saveStrategyLoading">下一步</span>
						<span v-else>保 存 中...</span>
					</el-button>
				</span>
			</div>
			<div v-if="activeStep===3" style="margin-top:10px;">
				<el-table v-loading="listLoading" :data="filedList" border fit highlight-current-row style="width: 100%">
					<el-table-column align="center" label="编码">
						<template slot-scope="scope">
							<span>{{ scope.row.fieldCode }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" label="名称">
						<template slot-scope="{row}">
							<el-input v-model="row.fieldName" class="edit-input" size="small" />
						</template>
					</el-table-column>
					<el-table-column align="center" label="是否查询条件">
						<template slot-scope="{row}">
							<el-checkbox v-model="row.canQuery" true-label="1" false-label="0"></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column align="center" label="查询顺序">
						<template slot-scope="{row}">
							<el-input v-model="row.queryIndex" class="edit-input" size="small" />
						</template>
					</el-table-column>
					<el-table-column align="center" label="是否表格显示">
						<template slot-scope="{row}">
							<el-checkbox v-model="row.canTable" true-label="1" false-label="0"></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column align="center" label="表格显示顺序">
						<template slot-scope="{row}">
							<el-input v-model="row.tableIndex" class="edit-input" size="small" />
						</template>
					</el-table-column>
					<el-table-column align="center" label="是否表单显示">
						<template slot-scope="{row}">
							<el-checkbox v-model="row.canForm" true-label="1" false-label="0"></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column align="center" label="显示类型">
						<template slot-scope="{row}">
							<el-select v-model="row.formType" placeholder="请选择">
								<el-option v-for="item in formTypeData" :key="item.id" :label="item.label" :value="item.id">
								</el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column align="center" label="是否必填">
						<template slot-scope="{row}">
							<el-checkbox v-model="row.formRequired" true-label="1" false-label="0"></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column align="center" label="最小值">
						<template slot-scope="{row}">
							<el-input v-model="row.formMin" class="edit-input" size="small" />
						</template>
					</el-table-column>
					<el-table-column align="center" label="是否必填">
						<template slot-scope="{row}">
							<el-input v-model="row.formMax" class="edit-input" size="small" />
						</template>
					</el-table-column>
					<el-table-column align="center" label="数据源">
						<template slot-scope="{row}">
							<el-select v-model="row.dataSourceId" placeholder="请选择">
								<el-option v-for="item in dictConfigData" :key="item.id" :label="item.label" :value="item.id">
								</el-option>
							</el-select>
						</template>
					</el-table-column>
				</el-table>
				<div style="margin-top:20px;text-align:center;">
					<el-button type="warning" class="ml-10" @click="back">返回</el-button>
					<el-button type="warning" class="ml-10" @click="prvBack">上一步</el-button>
					<el-button type="primary" @click="saveFieldInfo">
						<span v-if="!saveFieldLoading">生成</span>
						<span v-else>保 存 中...</span>
					</el-button>
				</div>
			</div>
	</div>
</template>
<script>
  import fwUtil from 'framework-util'
	import {
		generalTableService
	} from '../../../api/generator/generator/generalTable'
	import {
		generalStrategyService
	} from '../../../api/generator/generator/generalStrategy'
	import {
		generalFieldService,
		saveAllService
	} from '../../../api/generator/generator/generalField'
	import {
		TABLE_DATA_CONFIG
	} from './config/table.js'
	import {
		STRATEGY_DATA_CONFIG
	} from './config/strategy.js'
	import {
		FIELD_DATA_CONFIG
	} from './config/fields.js'

	export default {
		name: 'SplitpaneDemo',
		components: {
		},
		data() {
			return {
				activeStep: 1,
				tableId: '',
				saveStrategyLoading: false,
				saveFieldLoading: false,
				filedList: [],
				listLoading: false,
				formTypeData: [],
				dictConfigData: [],
				tableConfigData: TABLE_DATA_CONFIG,
				strategyConfigData: STRATEGY_DATA_CONFIG,
				fieldConfigData: FIELD_DATA_CONFIG,
				generalTableService: generalTableService,
				generalStrategyService: generalStrategyService,
				generalFieldService: generalFieldService
			}
		},
		mounted() {
			//this.createFormType();
			//this.createDictConfig();
			this.getFormTypeMethod();
			this.getDictConfitMethod();
		},
		methods: {
			stragetyonfig(row) {
				let that = this;
				this.tableId = row.id;
				generalTableService.update(row.id, row).then(res => {
					that.activeStep = 2;
					that.selectStragety();
				})
			},
			selectStragety() {
				let that = this;
				generalStrategyService.all({
					tableId: this.tableId
				}).then((res) => {
					if (res.length > 0) {
						that.strategyConfigData.formModel = res[0];
					} else {
						for (var p in that.strategyConfigData.formModel) { //遍历json数组时，这么写p为索引，0,1
							that.strategyConfigData.formModel[p] = '';
						}
						that.strategyConfigData.formModel.tableId = that.tableId;
					}

				})
			},
			getFormTypeMethod() {
				let that = this;
				fwUtil.DictUtil.getFormType().then(res => {
					that.formTypeData = res;
				});
			},
			getDictConfitMethod() {
				var that = this;
				fwUtil.DictUtil.getDictConfig().then(res => {
					that.dictConfigData = res.data;
				})
			},
			back() {
				this.activeStep = 1;
			},
			prvBack() {
				this.activeStep = 2;
			},
			saveFieldInfo() {
				let that = this;
				saveAllService(this.tableId, this.filedList).then((res) => {
					that.getAllFileds(that.tableId);
				});
			},
			saveStrategyForm() {
				this.$refs.strategyForm.submitForm();
			},
			saveStrategy(data) {
				let that = this;
				if (data.id) {
					generalStrategyService.update(data.id, data).then((res) => {
						that.activeStep = 3;
						that.getAllFileds(data.tableId);
					})
				} else {
					generalStrategyService.create(data).then((res) => {
						that.activeStep = 3;
						that.getAllFileds(data.tableId);
						//that.getAllFileds(data.tableId);
					})
				}

			},
			getAllFileds(tableId) {
				let that = this;
				generalFieldService.all({
					tableId: tableId
				}).then(res => {
					that.filedList = res;
				})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/generator/createCode/index.vue